/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".message-body[_ngcontent-%COMP%]{height:140px}.message-body[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{resize:none}om-profile-bubble[_ngcontent-%COMP%]{position:absolute;left:0}  .section{margin-bottom:1rem}  .section h5{font-weight:400;padding-left:40px}@media (max-width:767.98px){  .section{padding:0 1rem}  .section h5{padding-left:40px}}"];
export { styles as styles };
